import { Component, OnInit, ViewChild } from "@angular/core";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { pluck } from "rxjs";
import { Router } from "@angular/router";
import { v4 as uuidv4 } from "uuid";
import { GenericResponseDto } from "../../../../core/models/generic-response.dto";
import { ApplyCreditCard } from "../../../../core/models/orders/applyCreditCard";
import { CustomerPaymentMethodDto } from "../../../../core/models/orders/customerPaymentMethodDto";
import { GetBacForSalesOrderDto } from "../../../../core/models/orders/getBacForSalesOrderDto";
import { GetBCForSalesOrderDto } from "../../../../core/models/orders/getBCForSalesOrderDto";
import { InvoicedEmailDto } from "../../../../core/models/orders/invoicedEmailDto";
import { CreateQuotesRequestDto } from "../../../../core/models/qoutes/createQuotesRequestDto";
import { AddressCountryRegion } from "../../../../core/models/shared/countryRegionList";
import { Currency } from "../../../../core/models/shared/currencyList";
import { ShippingMethod } from "../../../../core/models/shared/shippingMethod";
import { UsersList } from "../../../../core/models/users/users/usersList";
import { ValidateLogin } from "../../../../core/models/validate-login.dto";
import { AddNewClientService } from "../../../../core/services/add-new-client.service";
import { ClientDetailsService } from "../../../../core/services/client-details.service";
import { CreateHeaderQuoteService } from "../../../../core/services/create-header-quote.service";
import { LoaderService } from "../../../../core/services/loader.service";
import { ProfileFormService } from "../../../../core/services/profile-form.service";
import { SaleOrderService } from "../../../../core/services/sale-order.service";
import { SamplepoListingService } from "../../../../core/services/samplepo-listing.service";
import { ShipToAddressComponent } from "../../../../shared/components/ship-to-address/ship-to-address.component";
import { EnumContactType } from "../../../../shared/enums/enumContactType";
import { ClientSearchList } from "../../../../core/models/shared/clientSearchList";
import { UserManagementService } from "../../../../core/services/user-management.service";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { CommonModule } from "@angular/common";
import { HeaderQuoteComponent } from "../header-quote/header-quote.component";
import { HeaderCustomerAddressComponent } from "../header-customer-address/header-customer-address.component";
import { HeaderInvoiceEmailsComponent } from "../header-invoice-emails/header-invoice-emails.component";
import { HeaderDetailsComponent } from "../header-details/header-details.component";
import { QuotesInvoiceEmail } from "../../../../core/models/qoutes/quotesInvoiceEmail";
import { CardModule } from "primeng/card";
import { ButtonModule } from "primeng/button";
import { ClientAddressCustomize } from "../../../../core/models/client/details/clientAddresscustomize";
import { ClientContact } from "../../../../core/models/client/details/clientContact";
import { GetUserProjectDto } from "../../../../core/models/samplePO/details/getUserProjectDto";
@UntilDestroy()
@Component({
  selector: "jni-create-header-quote",
  imports: [
    CommonModule,
    ReactiveFormsModule,
    HeaderQuoteComponent,
    ShipToAddressComponent,
    HeaderCustomerAddressComponent,
    HeaderInvoiceEmailsComponent,
    HeaderDetailsComponent,
    CardModule,
    ButtonModule,
  ],
  templateUrl: "./create-header-quote.component.html",
  styleUrls: ["./create-header-quote.component.scss"],
})
export class CreateHeaderQuoteComponent implements OnInit {
  showSmallLoader = false;
  invoiceListing: QuotesInvoiceEmail[] = [
    {
      id: 1,
      name: "Linda Brigs",
      purpose: "Accounts Payable",
      email: "megan@teslamotors.com",
      save: false,
      exist: false,
      confirmation: false,
      invoice: false,
      salesOrderIdD365: null,
      invoiceEmailRecIdD365: 0,
      modifiedDateTime1: "",
      portalKey: "",
      statusD365: "",
      messageD365: "",
      statusCodeD365: null,
      createdDate: "",
      createdBy: "",
      lastModifiedDate: null,
      lastModifiedBy: null,
      isActive: false,
    },
    {
      id: 2,
      name: "Linda Brigs",
      purpose: "Accounts Payable",
      email: "megan@teslamotors.com",
      save: false,
      exist: false,
      confirmation: false,
      invoice: false,
      salesOrderIdD365: null,
      invoiceEmailRecIdD365: 0,
      modifiedDateTime1: "",
      portalKey: "",
      statusD365: "",
      messageD365: "",
      statusCodeD365: null,
      createdDate: "",
      createdBy: "",
      lastModifiedDate: null,
      lastModifiedBy: null,
      isActive: false,
    },
    {
      id: 3,
      name: "Linda Brigs",
      purpose: "Accounts Payable",
      email: "megan@teslamotors.com",
      save: false,
      exist: false,
      confirmation: false,
      invoice: false,
      salesOrderIdD365: null,
      invoiceEmailRecIdD365: 0,
      modifiedDateTime1: "",
      portalKey: "",
      statusD365: "",
      messageD365: "",
      statusCodeD365: null,
      createdDate: "",
      createdBy: "",
      lastModifiedDate: null,
      lastModifiedBy: null,
      isActive: false,
    },
  ];
  QuoteForm!: FormGroup;
  brandingConsultantLists: GetBCForSalesOrderDto[] = [];
  addressBookName = "";
  vendorAccountNumber = "";
  brandingConsultantObject!: GetBCForSalesOrderDto;
  bcList: UsersList[] = [];
  bacList: UsersList[] | GetBacForSalesOrderDto[] = [];
  bacUserDefaultSelectionId = "";
  currencyList: Currency[] = [];
  shippingProductsList: ShippingMethod[] = [];
  countryRegionList: AddressCountryRegion[] = [];
  customerBillToObject!: ClientSearchList;
  clientContacts: ClientContact[] = [];
  customerPaymentMethodList: CustomerPaymentMethodDto[] = [];
  userPersonnelNumber!: string;
  avaiableCredit = 0;
  isCustomerPoRequiredField = false;
  ClientAddresses: ClientAddressCustomize[] = [];
  redirectedFromWorkflow = false;

  @ViewChild("shipTo", { static: false })
  shipTo!: ShipToAddressComponent;

  @ViewChild("proposalHeaderDetails", { static: false })
  proposalHeaderDetails!: HeaderDetailsComponent;

  deliveryAddress = [
    {
      id: 1,
      name: "One Time",
      status: false,
    },
    {
      id: 2,
      name: "Bill To",
      status: true,
    },
    {
      id: 3,
      name: "Client Address Book",
      status: true,
    },
    {
      id: 4,
      name: "Multi Ship To",
      status: false,
    },
    {
      id: 5,
      name: "TBD",
      status: false,
    },
  ];
  applyCreditCardList: ApplyCreditCard[] = [
    {
      id: 0,
      name: "Freight",
    },
    {
      id: 1,
      name: "BC Ledger",
    },
  ];

  constructor(
    private _fb: FormBuilder,
    private _saleOrderService: SaleOrderService,
    private _toastr: JniToastrService,
    private route: Router,
    private _loaderService: LoaderService,
    private _samplepoListingService: SamplepoListingService,
    private _addNewClientService: AddNewClientService,
    private _createHeaderQuoteService: CreateHeaderQuoteService,
    private _profileFormService: ProfileFormService,
    private _loginService: UserManagementService,
    private _clientDetailsService: ClientDetailsService
  ) {
    this.initializeForm();
    const navigation = this.route.getCurrentNavigation();
    if (navigation?.extras?.state) {
      const state = navigation?.extras?.state as {
        accountNumber: string;
        buyer: string;
      };
      this.redirectedFromWorkflow = true;
      this.QuoteForm.patchValue({
        orderHeader: {
          customerId: state.accountNumber,
          customerIdValid: state.accountNumber,
          buyer: state.buyer,
        },
      });
    }
  }

  formErrors: Record<string, string> = {
    jobName: "",
    brandingConsultant: "",
    methodOfPaymentHeader: "",
    customerIdValid: "",
    shipDate: "",
    inHandsDate: "",
    addressSelectionName: "",
    countryRegionIdD365: "",
    customerPONumber: "",
    deliveryNameD365: "",
  };

  validationMessages: Record<string, Record<string, string>> = {
    jobName: {
      required: "Job name is required.",
      minlength: "Job name must be greater than 2 characters.",
      maxlength: "Job name must be less than 300 characters.",
    },
    brandingConsultant: {
      required: "Branding consultant is required.",
      minlength: "Job name must be greater than 2 characters.",
      maxlength: "Job name must be less than 50 characters.",
    },
    accountsCoordinator: {
      required: "Accounts coordinator is required.",
    },
    methodOfPaymentHeader: {
      required: "Payment method is required.",
    },
    customerIdValid: {
      required: "Client/Lead is required.",
    },
    shipDate: {
      required: "Ship date is required.",
    },
    inHandsDate: {
      required: "In-Hands date is required.",
    },
    addressSelectionName: {
      required: "Delivery is required.",
    },
    countryRegionIdD365: {
      required: "Country is required.",
    },
    customerPONumber: {
      required: "Client PO Number is required.",
    },
    deliveryNameD365: {
      maxlength: "Name must be less than 100 characters.",
    },
  };

  ngOnInit(): void {
    this.disabledCustomerField();
    //this.getAllBcUsers();
    this.getCurrencyListData();
    this.getAllShippingMethod();
    this.getCountryRegionListData();
    this.getMehtodPaymentListData();
    this.getUserProfile();
  }

  logValidationErrors(group: FormGroup = this.QuoteForm): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } else {
        this.formErrors[key] = "";
        if (
          abstractControl &&
          !abstractControl.valid &&
          (abstractControl.touched || abstractControl.dirty)
        ) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey && messages) {
              this.formErrors[key] += messages[errorKey] + " ";
            }
          }
        }
      }
    });
  }

  private initializeForm() {
    this.QuoteForm = this._fb.group({
      orderHeader: this._fb.group({
        customerId: ["", Validators.required],
        customerIdValid: ["", Validators.required],
        jobName: [
          "",
          [
            Validators.required,
            Validators.minLength(2),
            Validators.maxLength(300),
          ],
        ],
        inHandsDate: ["", Validators.required], //inhands
        shipDate: [""],
        methodOfPaymentHeader: ["", Validators.required],
        brandingConsultant: [
          "",
          [
            Validators.required,
            Validators.minLength(2),
            Validators.maxLength(50),
          ],
        ],
        accountsCoordinator: ["", Validators.required], // account co-ordinator
        type: [""],
        buyer: [""],
      }),
      customerAddress: this._fb.group({
        name: [""],
        address: [""],
        telephone: [""],
        billingLocationD365: [""],
        billingAttentionD365: [""],
      }),
      shipTo: this._fb.group({
        deliveryAddress: [""],
        attention: [""],
        countryRegionIdD365: ["", Validators.required],
        zipCodeD365: [""],
        cityD365: [""],
        stateD365: [""],
        addressD365: [""],
        streetD365: ["", Validators.required],
        purposeD365: [""],
        isPrimaryD365: "1",
        rSMJNIShipToEmailD365: [""],
        addressBook: [""],
        buildingComplimentD365: [""],
        apartment_RUD365: [""],
        postBoxD365: [""],
        countyD365: [""],
        streetNumberD365: [""],
        districtNameD365: [""],
        saveAddress: [false],
        attentionInformationD365: [""],
        siteD365: [""],
        addressSelectionName: ["", Validators.required],
        locationD365: [""],
        addressLocationNumber: 0,
        addressFormat: [""],
        validateAddress: [""],
        melissaAddressKeyD365: [""],
        addressLine1: [""],
        addressLine2: [""],
        addressLine3: [""],
        deliveryNameD365: ["", Validators.maxLength(100)],
      }),
      orderDetails: this._fb.group({
        // buyer: [''],
        shippingMethod: [""],
        foreignCurrency: ["USD"],
        customerPONumber: [""],
        shippingMethodName: [""],
        methodOfPayment: [""],
        creditCardFeeCharge: 0,
        foreignCurrencyStatus: [false],
        account: [""],
      }),
      invoicedEmails: this._fb.array([]),
      portalKey: "",
    });
  }

  createInvoiceEmail(invoicedEmail: InvoicedEmailDto) {
    return this._fb.group({
      electronicAddressIdD365:
        invoicedEmail.electronicAddressIdD365 || uuidv4(),
      name: invoicedEmail.name || "",
      purpose: invoicedEmail.purpose || "",
      email: invoicedEmail.email || "",
      confirmation: invoicedEmail.confirmation,
      exist: invoicedEmail.exist,
      invoiced: invoicedEmail.invoiced,
      save: invoicedEmail.save,
    } as InvoicedEmailDto);
  }

  addInvoiceEmail(
    invoicedEmail: InvoicedEmailDto = {
      electronicAddressIdD365: uuidv4(),
      exist: false,
      invoiced: false,
      save: false,
      confirmation: false,
      email: "",
      name: "",
      purpose: "",
    }
  ) {
    const control = this.QuoteForm.get("invoicedEmails") as FormArray;
    control.push(this.createInvoiceEmail(invoicedEmail));
    this.disableExisitInvoiceEmail();
  }

  clearShipAddressForm() {
    //this.shipTo.clearNewShifToForm();
  }

  getLoaderStatus(status: boolean) {
    this.showSmallLoader = status;
  }

  addNewLine(event: boolean) {
    if (event) {
      const invoicedEmail: InvoicedEmailDto = {
        electronicAddressIdD365: uuidv4(),
        exist: false,
        invoiced: false,
        save: false,
        confirmation: false,
        email: "",
        name: "",
        purpose: "",
      };
      const control = this.QuoteForm.get("invoicedEmails") as FormArray;
      control.insert(0, this.createInvoiceEmail(invoicedEmail));
      this.disableExisitInvoiceEmail();
      // this.addInvoiceEmail();
    }
  }
  removeEmail(formgroup: FormGroup[]) {
    formgroup.forEach(x => {
      const value = x.get("electronicAddressIdD365")?.value;
      for (
        let i = 0;
        i < (this.QuoteForm.get("invoicedEmails") as FormArray).length;
        i++
      ) {
        if (
          (this.QuoteForm.get("invoicedEmails") as FormArray)
            .at(i)
            .get("electronicAddressIdD365")?.value == value
        ) {
          (this.QuoteForm.get("invoicedEmails") as FormArray).removeAt(i--);
        }
      }
    });
  }

  disabledCustomerField() {
    this.QuoteForm.get(["customerAddress", "name"])?.disable();
    this.QuoteForm.get(["customerAddress", "address"])?.disable();
    this.QuoteForm.get(["customerAddress", "telephone"])?.disable();
    this.QuoteForm.get(["customerAddress", "billingAttentionD365"])?.disable();
    this.QuoteForm.get(["customerAddress", "billingLocationD365"])?.disable();
    this.QuoteForm.get(["orderDetails", "foreignCurrency"])?.disable();
    this.QuoteForm.get(["orderDetails", "shippingMethodName"])?.disable();
  }

  patchInHandDate() {
    const currentDate = new Date().toISOString();
    this.QuoteForm.patchValue({
      orderHeader: {
        inHandsDate: currentDate,
        shipDate: currentDate,
      },
    });
  }

  getAllBcUsers() {
    this._samplepoListingService
      .getAllBrandingConsultant()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (res: GenericResponseDto<GetUserProjectDto[]>) => {
          if (res.data != null) {
            this.brandingConsultantLists = res.data;
            if (this.brandingConsultantLists) {
              if (this.brandingConsultantLists.length > 0) {
                this.brandingConsultantObject = this.brandingConsultantLists[0];
                this.patchValueInBrandingConsultant(
                  this.brandingConsultantLists[0]
                );
                this.getBACList(res.data[0].id);
              }
            }
          }
          this.showSmallLoader = false;
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }

  patchValueInBrandingConsultant(data: GetBCForSalesOrderDto | string) {
    this.QuoteForm.patchValue({
      orderHeader: {
        brandingConsultant: data,
      },
    });
  }

  getBACList(id: number) {
    this._addNewClientService
      .getBACList(id)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (res: GenericResponseDto<UsersList[]>) => {
          this.bacList = res.data;
          // const obj = this.bacList.filter((x) => x.isPrimary == true);
          // if (obj.length > 0) {
          //   this.bacUserDefaultSelectionId = obj[0].personnelNumber;
          // }
        },
      });
  }

  getCurrencyListData() {
    this._addNewClientService
      .getCurrencyList()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.currencyList = res.data;
        },
      });
  }

  getMehtodPaymentListData() {
    const params = "?";
    this._saleOrderService
      .getMethodPaymentList(params)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.customerPaymentMethodList = res.data;
        },
      });
  }

  getAllShippingMethod() {
    this._samplepoListingService
      .getAllShippingMethod()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          const shippingData = res.data;
          this.shippingProductsList = shippingData.filter(
            x => x.jniUseOnSalesOrderD365 !== "No"
          );
        },
      });
  }

  getCountryRegionListData() {
    this._addNewClientService
      .getCountryRegionList()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.countryRegionList = res?.data;
        },
      });
  }

  getCustomerBillToData(clientObj: ClientSearchList) {
    this.customerBillToObject = clientObj;
    this.getAllContactsByAccountNumber(
      this.customerBillToObject?.clientAccount,
      this.customerBillToObject?.partyNumber
    );
    this.getShippingMethodByCustomer(clientObj);

    this.getBCForSalesOrder(
      clientObj.clientAccount,
      clientObj.bcPersonnelNumberD365 ?? ""
    );

    this.getAvailableCredit(this.customerBillToObject?.clientAccount);

    const delivery = this.QuoteForm.get([
      "shipTo",
      "addressSelectionName",
    ])?.value;
    if (
      delivery === "Bill To" ||
      delivery === "Bill to" ||
      delivery === "Client Address Book" ||
      delivery === "Client address book" ||
      delivery == "Address book" ||
      delivery == "To address book"
    ) {
      this.shipTo.clearNewShifToForm();
    }

    this.isCustomerPOFieldRequired(this.customerBillToObject?.clientAccount);
  }

  isCustomerPOFieldRequired(accountNumber: string) {
    this._clientDetailsService
      .IsCustomerPOFieldRequired(accountNumber)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res.data) {
            this.setCustomerPoRequiredField();
          } else {
            this.removeCustomerPoRequiredField();
          }
        },
        error: res => {
          this._toastr.error(res.message, "Error");
        },
      });
  }

  setCustomerPoRequiredField() {
    this.isCustomerPoRequiredField = true;
    this.QuoteForm.get(["orderDetails", "customerPONumber"])?.setValidators(
      Validators.required
    );
    this.QuoteForm.get([
      "orderDetails",
      "customerPONumber",
    ])?.updateValueAndValidity();
  }

  removeCustomerPoRequiredField() {
    this.isCustomerPoRequiredField = false;
    this.QuoteForm.get(["orderDetails", "customerPONumber"])?.clearValidators();
    this.QuoteForm.get([
      "orderDetails",
      "customerPONumber",
    ])?.updateValueAndValidity();
  }

  transformClientContactData() {
    this.ClientAddresses = [];
    // this.QuoteForm.patchValue({
    //   orderDetails: {
    //     buyer: ''
    //   }
    // });
    // const Business = this.clientContacts?.filter(
    //   (x) => x.purposeD365 == ClientPurposeType.Business
    // );
    // this.populateClientContactInformation(Business);
    // const Invoice = this.clientContacts?.filter(
    //   (x) => x.purposeD365 == ClientPurposeType.Invoice
    // );
    // this.populateClientContactInformation(Invoice);
    // const Payment = this.clientContacts?.filter(
    //   (x) => x.purposeD365 == ClientPurposeType.Payment
    // );
    // this.populateClientContactInformation(Payment);
    // const Delivery = this.clientContacts?.filter(
    //   (x) => x.purposeD365 == ClientPurposeType.Delivery
    // );
    // this.populateClientContactInformation(Delivery);
    // const Other = this.clientContacts?.filter(
    //   (x) => x.purposeD365 == ClientPurposeType.Other
    // );
    // this.populateClientContactInformation(Other);
    // const Buyer = this.clientContacts?.filter(
    //   (x) => x.purposeD365 == ClientPurposeType.Buyer
    // );
    this.populateClientContactInformation(this.clientContacts);
  }

  populateClientContactInformation(
    clientContacts: ClientContact[] | undefined
  ) {
    if (
      clientContacts != null &&
      clientContacts != undefined &&
      clientContacts.length > 0
    ) {
      clientContacts.forEach(element => {
        if (element?.locatorD365) {
          const clientAddress: ClientAddressCustomize = {};
          clientAddress.purpose = element.purposeD365;
          clientAddress.isPrimary = element.isPrimaryD365;
          clientAddress.name = element.descriptionD365;
          clientAddress.cust = element.cust;
          clientAddress.title = element.title;
          clientAddress.electronicAddressIdD365 =
            element.electronicAddressIdD365;

          if (element.typeD365 == EnumContactType.Phone) {
            clientAddress.phone = element.locatorD365;
            clientAddress.phoneLink = "tel:'" + element.locatorD365 + "'";
          } else if (element.typeD365 == EnumContactType.Email) {
            clientAddress.email = element.locatorD365;
            clientAddress.emailLink = "mailto:'" + element.locatorD365 + "'";
          }
          if (clientAddress.name) {
            this.ClientAddresses.push(clientAddress);
          }
        }
      });
    }
  }

  bcSelectionForProspect(event: GetBCForSalesOrderDto) {
    this.brandingConsultantLists = [];
    this.brandingConsultantLists.push(event);
    this.getBacForSalesOrder(event.personnelNumber);
  }

  getAvailableCredit(accountNumber: string) {
    this._clientDetailsService
      .getAvailableCredit(accountNumber)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.status.toLowerCase() != "success") {
            this.avaiableCredit = 0;
            this._toastr.error(res.message, "Error");
          } else {
            this.avaiableCredit = res?.data?.availableCredit;
          }
        },
        error: () => {
          this.avaiableCredit = 0;
          this._loaderService.setLoaderState(false);
        },
      });
  }

  getBCForSalesOrder(accountNumber: string, bcNumber: string) {
    this._saleOrderService
      .getBCForSalesOrder(accountNumber)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res.data != null) {
            this.brandingConsultantLists = res.data;

            const filterBcObject = this.brandingConsultantLists.filter(
              x => x.personnelNumber === bcNumber
            );
            if (filterBcObject.length > 0) {
              this.patchValueInBrandingConsultant(
                filterBcObject[0].projectName
              );
            } else {
              if (this.brandingConsultantLists.length > 0) {
                this.patchValueInBrandingConsultant(
                  this.brandingConsultantLists[0].projectName
                );
              } else {
                this.patchValueInBrandingConsultant("");
              }
            }
            this.getBacForSalesOrder(filterBcObject[0]?.personnelNumber);
          }
        },
      });
  }

  getBacForSalesOrder(personnelNumber: string) {
    this._saleOrderService
      .getBacForSalesOrder(personnelNumber)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (res: GenericResponseDto<GetBacForSalesOrderDto[]>) => {
          if (res.data != null) {
            this.bacList = res.data;
            // const filterBacObject = res.data.filter(
            //   x => x.personnelNumber === this.userPersonnelNumber
            // );

            if (this.bacList.length > 0) {
              const obj = this.bacList.find(x => x.isPrimary);
              if (obj) {
                this.bacUserDefaultSelectionId = obj?.personnelNumber || "";
              }
              if (!this.bacUserDefaultSelectionId) {
                this.bacUserDefaultSelectionId =
                  this.bacList[0].personnelNumber;
              }
            } else {
              this.bacUserDefaultSelectionId = "";
            }

            this.patchValueInBacField(this.bacUserDefaultSelectionId);

            // if (filterBacObject.length > 0) {
            //   this.bacUserDefaultSelectionId =
            //     filterBacObject[0].personnelNumber;
            //   this.patchValueInBacField(this.bacUserDefaultSelectionId);
            // } else {
            //   if (this.bacList.length > 0) {
            //     this.bacUserDefaultSelectionId =
            //       this.bacList[0].personnelNumber;
            //     this.patchValueInBacField(this.bacUserDefaultSelectionId);
            //   } else {
            //     this.bacUserDefaultSelectionId = '';
            //   }
            // }
          }
        },
      });
  }

  patchValueInBacField(personnelNumber: string) {
    this.QuoteForm.patchValue({
      orderHeader: {
        accountsCoordinator: personnelNumber,
      },
    });
  }

  getUserProfile() {
    this._loginService
      .validateLogin()
      .pipe()
      .subscribe((res: GenericResponseDto<ValidateLogin>) => {
        this.getUserById(res?.data?.userId);
      });
  }

  getUserById(userId: number) {
    this._profileFormService.getUsersById(userId).subscribe({
      next: async res => {
        if (res.data != null) {
          this.userPersonnelNumber = res.data.personnelNumber;
        }
      },
    });
  }

  getShippingMethodByCustomer(clientObj: ClientSearchList) {
    if (clientObj) {
      const shippingobj = this.shippingProductsList.filter(
        x => x.modeCodeD365 === clientObj.shippingMethod
      );
      if (shippingobj.length > 0) {
        this.patchValueInShippingMethod(shippingobj[0]);
      }
    }
  }

  patchValueInShippingMethod(shippingobj: ShippingMethod) {
    this.QuoteForm.patchValue({
      orderDetails: {
        shippingMethod: shippingobj.modeCodeD365,
        shippingMethodName: shippingobj.modeDescriptionD365,
        account:
          shippingobj.useFreightAccountD365?.toLowerCase() === "yes"
            ? shippingobj.jniFreightAcctNumD365
            : "",
      },
    });
  }

  buyerChangeEvent() {
    this.getAllContactsByAccountNumber(
      this.customerBillToObject?.clientAccount,
      this.customerBillToObject?.partyNumber
    );
  }

  getAllContactsByAccountNumber(accountNumber: string, partyNumber = "") {
    this.showSmallLoader = true;
    this._saleOrderService
      .getAllContactsByAccountNumber(accountNumber, partyNumber)
      .pipe(pluck("data"))
      .subscribe({
        next: data => {
          this.showSmallLoader = false;
          const sortedData = data.sort((a, b) => {
            const dateA = a.createdDate ? new Date(a.createdDate) : new Date(0);
            const dateB = b.createdDate ? new Date(b.createdDate) : new Date(0);
            return dateB.getTime() - dateA.getTime();
          });
          this.clientContacts = sortedData;
          const invoicedEmails = sortedData.filter(
            x =>
              // 11313 - Create new order and select customer in it. Remove the check or pulling only emails with the purpose invoice when creating an order header in the portal
              // x.purposeD365?.toLowerCase() == 'invoice' &&
              x.typeD365?.toLowerCase() == "email"
          );

          const filteredInvoicedEmails = invoicedEmails.filter(
            (email, index) =>
              index ===
              invoicedEmails.findIndex(
                secondEmail => email.locatorD365 === secondEmail.locatorD365
              )
          );

          const control = this.QuoteForm.get("invoicedEmails") as FormArray;
          control.clear();

          filteredInvoicedEmails.forEach(x => {
            this.addInvoiceEmail({
              electronicAddressIdD365: x.electronicAddressIdD365 ?? uuidv4(),
              name: x.descriptionD365 ?? "",
              purpose: x.purposeD365 ?? "",
              email: x.locatorD365 ?? "",
              exist: true,
              invoiced: false,
              confirmation: false,
              save: true,
            });
          });
          this.disableSaveAndExisitInvoiceEmail();
          this.transformClientContactData();
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }

  private disableSaveAndExisitInvoiceEmail() {
    (this.QuoteForm.get("invoicedEmails") as FormArray).controls.forEach(
      group => {
        (group.get("save") as FormControl).disable();
        (group.get("exist") as FormControl).disable();
      }
    );
  }
  private disableExisitInvoiceEmail() {
    (this.QuoteForm.get("invoicedEmails") as FormArray).controls.forEach(
      group => {
        (group.get("exist") as FormControl).disable();
      }
    );
  }

  isEmailInvoiced(): boolean {
    const control = this.QuoteForm.get("invoicedEmails") as FormArray;
    for (let i = 0; i < control.length; i++) {
      if ((control.at(i) as FormGroup).get("invoiced")?.value) {
        return true;
      }
    }
    return false;
  }

  isEmailValid(): boolean {
    let isEmail = true;
    const control = this.QuoteForm.get("invoicedEmails") as FormArray;
    for (let i = 0; i < control.length; i++) {
      if ((control.at(i) as FormGroup).get("invoiced")?.value) {
        const email: string = (control.at(i) as FormGroup).get("email")?.value;
        const regex = `^[a-zA-Z0-9._%+-]+(?:'[a-zA-Z0-9._%+-]+)?@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$`;
        if (!RegExp(regex).exec(email)) {
          isEmail = false;
        }
      }
    }
    if (isEmail) {
      return true;
    }
    return false;
  }

  isEmailDuplicate(): boolean {
    const control = this.QuoteForm.get("invoicedEmails") as FormArray;
    const emailSet = new Set();
    for (let i = 0; i < control.length; i++) {
      emailSet.add((control.at(i) as FormGroup).get("email")?.value);
    }
    return control.length != emailSet.size;
  }

  EmailDuplicate(): boolean {
    const control = this.QuoteForm.get("invoicedEmails") as FormArray;
    for (let i = 0; i < control.length; i++) {
      const email = (control.at(i) as FormGroup).get("email")?.value;
      for (let j = i + 1; j < control.length; j++) {
        if (email == (control.at(j) as FormGroup).get("email")?.value) {
          this._toastr.error(
            "Error",
            `Email address "${email}". The record already exists.`
          );
          return true;
        }
      }
    }
    return false;
  }

  isEmailInvoicedEmpty(): boolean {
    const control = this.QuoteForm.get("invoicedEmails") as FormArray;
    for (let i = 0; i < control.length; i++) {
      if ((control.at(i) as FormGroup).get("invoiced")?.value) {
        const email = (control.at(i) as FormGroup).get("email")?.value;
        if (!email) {
          return true;
        }
      }
    }
    return false;
  }

  submitButtonlogValidationErrors(group: FormGroup = this.QuoteForm): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.submitButtonlogValidationErrors(abstractControl);
      } else {
        this.formErrors[key] = "";
        if (abstractControl && !abstractControl.valid) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey && messages) {
              this.formErrors[key] += messages[errorKey] + " ";
            }
          }
        }
      }
    });
  }

  onSubmit() {
    this.submitButtonlogValidationErrors();
    if (!this.isEmailInvoiced()) {
      this._toastr.error("Error", "Atleast one email should be invoiced");
      return;
    }

    if (this.isEmailInvoicedEmpty()) {
      this._toastr.error("Error", "Invoiced email should not empty");
      return;
    }

    if (!this.isEmailValid()) {
      this._toastr.error(
        "Error",
        "Atleast one valid invoice email is required"
      );
      return;
    }
    if (this.EmailDuplicate()) {
      return;
    }
    this._loaderService.setLoaderState(true);
    const QuoteFormObject =
      this.QuoteForm.getRawValue() as CreateQuotesRequestDto;

    // if (!QuoteFormObject['shipTo']?.streetD365) {
    //   if (
    //     QuoteFormObject['shipTo']?.addressSelectionName?.toLowerCase() !==
    //       'tbd' &&
    //     !(
    //       QuoteFormObject['shipTo']?.addressSelectionName?.toLowerCase() ==
    //         'multi ship to' ||
    //       QuoteFormObject['shipTo']?.addressSelectionName?.toLowerCase() ==
    //         'multiple ship-to' ||
    //       QuoteFormObject['shipTo']?.addressSelectionName
    //         ?.toLowerCase()
    //         .includes('drop')
    //     )
    //   ) {
    //     this._toastr.error('Error', 'Address is required');
    //     this._loaderService.setLoaderState(false);
    //     return;
    //   }
    // }

    if (QuoteFormObject.orderHeader && !QuoteFormObject.orderHeader?.shipDate) {
      QuoteFormObject.orderHeader.shipDate = "";
    }

    // if (
    //   QuoteFormObject['orderHeader'] &&
    //   !QuoteFormObject['orderHeader']?.inHandsDate
    // ) {
    //   QuoteFormObject['orderHeader'].inHandsDate = '';
    // }

    if (
      QuoteFormObject.orderHeader?.shipDate &&
      QuoteFormObject.orderHeader?.inHandsDate
    ) {
      if (
        new Date(QuoteFormObject.orderHeader?.inHandsDate) <
        new Date(QuoteFormObject.orderHeader?.shipDate)
      ) {
        this._loaderService.setLoaderState(false);
        this._toastr.error(
          "Error",
          "Inhands date header greater and equal to ship date header"
        );
        return;
      }
    }

    if (!QuoteFormObject.shipTo?.addressD365) {
      this._toastr.error("Error", "Ship to address is required");
    }
    if (!this.QuoteForm.valid) {
      this._loaderService.setLoaderState(false);
      return;
    }

    if (QuoteFormObject.orderHeader?.brandingConsultant) {
      const bcObject = this.brandingConsultantLists.filter(
        x => x.projectName === QuoteFormObject.orderHeader?.brandingConsultant
      );
      QuoteFormObject.orderHeader.brandingConsultant =
        bcObject[0].personnelNumber;
    }

    if (
      QuoteFormObject.shipTo &&
      QuoteFormObject.shipTo.addressLocationNumber === 0
    ) {
      QuoteFormObject.shipTo.addressLocationNumber = 0;
    }

    if (
      QuoteFormObject.shipTo?.addressSelectionName
        ?.toLowerCase()
        .includes("one")
    ) {
      QuoteFormObject.shipTo.addressLocationNumber = 0;
    }

    if (QuoteFormObject) {
      QuoteFormObject.portalKey = uuidv4();
    }

    if (QuoteFormObject.orderDetails != null) {
      QuoteFormObject.orderDetails.methodOfPayment =
        QuoteFormObject.orderHeader?.methodOfPaymentHeader;
    }

    if (QuoteFormObject.shipTo) {
      const formValue = this.QuoteForm.getRawValue();
      const value = formValue.shipTo.shipToVendorAccountNameD365 ?? "";
      QuoteFormObject.shipTo.deliveryAddressD365 = this.getDeliveryAddress(
        QuoteFormObject.shipTo.addressSelectionName ?? "",
        QuoteFormObject.shipTo.deliveryNameD365 ?? "",
        value ?? ""
      );
    }

    if (QuoteFormObject?.orderDetails && QuoteFormObject.orderHeader) {
      QuoteFormObject.orderDetails.buyer = QuoteFormObject.orderHeader.buyer;
    }

    if (QuoteFormObject.invoicedEmails) {
      QuoteFormObject.invoicedEmails.forEach((x: InvoicedEmailDto) => {
        if (x.save === undefined || !x.save) {
          x.save = false;
        }
        if (x.exist === undefined || !x.exist) {
          x.exist = false;
        }
        if (x.confirmation === undefined || !x.confirmation) {
          x.confirmation = false;
        }
      });
    }

    if (QuoteFormObject?.orderDetails) {
      QuoteFormObject.orderDetails.foreignCurrencyStatus =
        QuoteFormObject.orderDetails.foreignCurrency !== "USD";
    }

    this._createHeaderQuoteService
      .addQuoteHeaderData(QuoteFormObject)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.data) {
            this._toastr.success("Success", "Proposal added successfully");
            const url = `/proposal/add-line/${res?.data?.orderHeader?.salesOrderIdD365}`;
            this.route.navigate([url]);
          } else {
            this._toastr.error("Error", res.message || "Error adding proposal");
          }
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastr.error("Error", res.message || "Error adding proposal");
        },
      });
  }

  getDeliveryAddress(
    addressSelectionName: string,
    deliveryNameD365: string,
    shipToVendorAccountNameD365: string
  ) {
    if (addressSelectionName.toLowerCase().includes("one")) {
      return deliveryNameD365;
    } else if (addressSelectionName.toLowerCase().includes("bill")) {
      return deliveryNameD365;
    } else if (addressSelectionName.toLowerCase().includes("vendor")) {
      return shipToVendorAccountNameD365;
    } else if (addressSelectionName.toLowerCase().includes("address")) {
      return deliveryNameD365;
    } else if (addressSelectionName.toLowerCase().includes("branding")) {
      return deliveryNameD365;
    }
    return "";
  }

  contactListRefreshGrid(obj: boolean) {
    if (obj) {
      this.getCustomerBillToData(this.customerBillToObject);
    }
  }

  goToQuotesListing() {
    this.route.navigate(["/proposal"]);
  }

  patchValueInCurrencyFieldEvent(currency: string) {
    this.proposalHeaderDetails.patchValueInCurrency(currency);
  }
}
